// types
import { FieldTransform } from '../../../index'
// utils
import moment from 'moment'

export const fieldMap: Partial<Record<string, string | FieldTransform>> = {
  '1a59ddcf-5ba2-4214-afcd-cda5036ab93d': 'program',
  'de412742-1f49-41b1-93b8-71aaab898e77': 'location',
  '9bb2c42e-d99f-4186-81b7-589505b7e983': (value) => ({
    date: value ? moment(value).format('DD.MM.YYYY') : '',
    time: value ? moment(value).format('HH:mm') : ''
  }),
  'fe53c701-7567-4b6e-aea0-fcdfc388ec1c': (value) => ({
    clientName: value?.label ?? '',
    _clientUserId: value?.value ?? null
  }),
  '2d38f74e-95a7-48d1-b31f-8bfffbc7dee5': (value) => ({
    isCritical: value?.label === 'Critical',
    isNonCritical: value?.label === 'Non-Critical'
  }),
  '95efba2e-ffe6-4599-a594-503f84c56bdd': 'details',
  '07e645c4-da07-4a09-8336-8e43a7fa5da3': 'actionTaken',
  '59bfc4cf-11e1-4d16-85bd-df0f698eb412': (value) => ({
    employeeName: value?.label ?? '',
    employeeSignature: value?.label ?? ''
  }),
  'f81f7bce-a19a-42bf-bfaa-198b8bc00d25': 'employeePosition',
  '85ebc192-3e62-4fe2-9922-da31780de47f': (value) => ({
    employeeDate: value ? moment(value).format('DD.MM.YYYY HH:mm') : ''
  }),
  '7c3d6cc3-43f7-4a98-bb05-9c227a32b87a': (value) => ({
    managerName: value?.label ?? '',
    managerSignature: value?.label ?? ''
  }),
  '83a43abe-6fbf-4bd3-84da-e1132e77513c': 'managerPosition',
  '1c0b32d5-d604-40fd-97e0-b3579ccdc2ec': (value) => ({
    managerDate: value ? moment(value).format('DD.MM.YYYY HH:mm') : ''
  })
}
